module.exports = __webpack_public_path__ + "static/media/prop-h-faq.b5dc68a7.gif";